/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    negative: { type: 'variant', values: [ true ] },
    style: {
      description: 'Configure `style` variant for `ProgressBar`',
      type: 'variant',
      values: [ 'subtle', 'inverse', 'inactive', 'negative' ]
    }
  },
  rules: [
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#b2b9bf',
        gradient: null,
        outlineColor: '#2c2e30',
        shadow: null
      }
    },
    {
      if: { negative: true },
      tokens: {
        backgroundColor: '#c12335',
        gradient: null,
        outlineColor: '#c12335',
        shadow: null
      }
    },
    {
      if: { style: 'inactive' },
      tokens: {
        backgroundColor: '#b2b9bf',
        gradient: null,
        outlineColor: '#2c2e30',
        shadow: null
      }
    },
    {
      if: { style: 'negative' },
      tokens: {
        backgroundColor: '#c12335',
        gradient: null,
        outlineColor: '#c12335',
        shadow: null
      }
    },
    {
      if: { style: 'subtle' },
      tokens: {
        backgroundColor: '#676e73',
        gradient: null,
        outlineColor: '#676e73'
      }
    },
    {
      if: { style: 'inverse' },
      tokens: {
        backgroundColor: '#ffffff',
        gradient: null,
        outlineColor: '#ffffff'
      }
    }
  ],
  tokens: {
    backgroundColor: '#2b8000',
    borderRadius: 12,
    gradient: {
      angle: 135,
      stops: [
        { color: '#00784a', hint: 0.75, stop: 0 },
        { color: '#66cc00', stop: 1 }
      ],
      type: 'linear'
    },
    outlineColor: '#2b8000',
    outlineWidth: 1,
    shadow: {
      blur: 1,
      color: 'rgba(255, 255, 255, 0.8)',
      inset: true,
      offsetX: 0,
      offsetY: 1,
      spread: 0
    }
  }
}
export default theme
